import { useEffect } from 'react';
import { FORM_FIELDS } from '../../../constants';
import { provider } from '../../../helpers/client';
import { useFormFields } from '../../../store/selectors/formStore';
import { useDispatch } from 'react-redux';
import { extendFormData } from '../../../store/reducers/formStore';
import { TaskManager } from '../../../helpers/form.new/task.manager';

const cachedRoutes = new Map<string, string | null>();

/** @todo Перенести в более удачное место */
const loadRoute = async (address: string): Promise<undefined | string> => {
    const validAddress = address.split(/,\s?/).slice(0, 3).join(', ');
    if (!cachedRoutes.get(validAddress.trim())) {
        const location = await provider.locationForRoute(validAddress);
        cachedRoutes.set(validAddress.trim(), (location && location.route) || null);
    }
    return cachedRoutes.get(validAddress.trim()) || '';
};

const useWatchRoute = (addressName: string, routeName: string, taskManager: TaskManager) => {
    const [addressForm] = useFormFields([addressName]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (addressForm) {
            taskManager.register(
                loadRoute(addressForm).then((route) => dispatch(extendFormData({ [routeName]: route }))),
            );
        }
    }, [addressForm, routeName, dispatch, taskManager]);
};

export const useRouteLoader = (taskManager: TaskManager) => {
    useWatchRoute(FORM_FIELDS.REGISTRATION_STREET, FORM_FIELDS.REGISTRATION_ROUTE, taskManager);
    useWatchRoute(FORM_FIELDS.RESIDENCE_STREET, FORM_FIELDS.RESIDENCE_ROUTE, taskManager);
    useWatchRoute(FORM_FIELDS.WORK_ADDRESS, FORM_FIELDS.WORK_ROUTE, taskManager);
};
